import React, { useContext } from "react";
import "./Latest_updates_content.css";
import Common_Back_Btn from "../../../../common_components/common_back_btn/Common_Back_Btn";
import { Context } from "../../../../../utils/context";
import { formatDate } from "../../../../../utils/common";

function Latest_updates_content({ news }) {
  const { IMG_URL } = useContext(Context);

  return (
    <>
      <section className="Latest_updates_content">
        <div className="custom_container">
          <Common_Back_Btn backText="Back" />
          <div className="row mt-3">
            <div className="col-md-7 order-md-1 order-2">
              <div className="img_holder">
                <img
                  src={IMG_URL + news?.image}
                  alt={news?.name}
                  className="Latest_updates_img"
                />

                <span>{formatDate(news?.createdAt)}</span>
              </div>
              {/* 
              <div className="text_holder">
                <p>
                  When it comes to gifting, few things rival the timeless
                  elegance and sophistication of luxury home décor items.
                  Whether you're celebrating a special occasion, expressing
                  gratitude, or simply adding a touch of opulence to your loved
                  one's living space, luxury home décor gifts are sure to leave
                  a lasting impression. Here are some exquisite ideas to inspire
                  your next gift-giving gesture:
                </p>
              </div>

              <div className="text_holder">
                <p>1. Stunning Flower Vases: </p>
                <p>
                  Elevate any floral arrangement with a statement flower vase
                  crafted from the finest materials. Opt for crystal vases
                  adorned with intricate patterns or hand-painted porcelain
                  vases for a touch of Old-World charm. A luxurious flower vase
                  not only enhances the beauty of fresh blooms but also serves
                  as a timeless keepsake.
                </p>
              </div>

              <div className="text_holder">
                <p> 2. Elegant Pottery: </p>
                <p>
                  Gift a piece of artistry with handcrafted pottery that exudes
                  elegance and craftsmanship. Choose from delicate porcelain tea
                  sets, artisanal ceramic bowls, or intricately designed serving
                  platters to add a touch of sophistication to any dining table.
                  Each piece tells a story of tradition, skill, and creativity,
                  making it a cherished addition to any home. 3. Fine Crockery
                  Sets: Elevate everyday dining experiences with luxurious
                  crockery sets that combine style and functionality. Treat your
                  loved ones to fine bone china dinnerware embellished with
                  exquisite patterns or sleek contemporary designs crafted from
                  premium materials like porcelain or stoneware. From elegant
                  dinner plates to delicate tea sets, luxury crockery sets
                  promise to make every meal a special occasion. 4. Decorative
                  Figurines: Add a touch of whimsy and charm to any living space
                  with decorative figurines that serve as exquisite works of
                  art. Choose from intricately sculpted bronze statues,
                  hand-blown glass figurines, or delicately carved marble
                  sculptures to adorn shelves, mantels, or display cabinets.
                  These luxurious accents not only elevate the aesthetic appeal
                  of any room but also serve as timeless conversation pieces. 5.
                  Statement Wall Art: Transform any room into a gallery-worthy
                  space with statement wall art that captures the imagination &
                  inspires awe. Choose from breathtaking oil paintings,
                  mesmerizing tapestries, or contemporary metal sculptures to
                  create a focal point that reflects your loved one's
                  personality and style. Whether it's a vibrant abstract canvas
                  or a serene landscape masterpiece, luxury wall art adds depth,
                  dimension, & character to any interior décor scheme.
                  Conclusion: From exquisite flower vases to elegant crockery
                  sets, luxury home décor gifts offer a perfect blend of beauty,
                  functionality, & sophistication. Whether you're gifting for a
                  special occasion or simply expressing appreciation, these
                  exquisite items are sure to make a lasting impression & bring
                  joy to any recipient's home.
                </p>
              </div>

              <div className="text_holder">
                <p> 3. Fine Crockery Sets: </p>
                <p>
                  Elevate everyday dining experiences with luxurious crockery
                  sets that combine style and functionality. Treat your loved
                  ones to fine bone china dinnerware embellished with exquisite
                  patterns or sleek contemporary designs crafted from premium
                  materials like porcelain or stoneware. From elegant dinner
                  plates to delicate tea sets, luxury crockery sets promise to
                  make every meal a special occasion.
                </p>
              </div>

              <div className="text_holder">
                <p> 4. Decorative Figurines: </p>
                <p>
                  Add a touch of whimsy and charm to any living space with
                  decorative figurines that serve as exquisite works of art.
                  Choose from intricately sculpted bronze statues, hand-blown
                  glass figurines, or delicately carved marble sculptures to
                  adorn shelves, mantels, or display cabinets. These luxurious
                  accents not only elevate the aesthetic appeal of any room but
                  also serve as timeless conversation pieces.
                </p>
              </div>

              <div className="text_holder">
                <p> 5. Statement Wall Art:</p>
                <p>
                  Transform any room into a gallery-worthy space with statement
                  wall art that captures the imagination & inspires awe. Choose
                  from breathtaking oil paintings, mesmerizing tapestries, or
                  contemporary metal sculptures to create a focal point that
                  reflects your loved one's personality and style. Whether it's
                  a vibrant abstract canvas or a serene landscape masterpiece,
                  luxury wall art adds depth, dimension, & character to any
                  interior décor scheme.
                </p>
              </div>

              <div className="text_holder">
                <p> Conclusion: </p>
                <p>
                  From exquisite flower vases to elegant crockery sets, luxury
                  home décor gifts offer a perfect blend of beauty,
                  functionality, & sophistication. Whether you're gifting for a
                  special occasion or simply expressing appreciation, these
                  exquisite items are sure to make a lasting impression & bring
                  joy to any recipient's home.
                </p>
              </div> */}
              <div
                className="text_holder"
                dangerouslySetInnerHTML={{ __html: news.long_description }}
              />
            </div>

            <div className="col-md-5 order-md-2 order-1">
              <div className="text_holder">
                <h1>{news?.name}</h1>
                <h2>{news?.by_name}</h2>

                <div dangerouslySetInnerHTML={{ __html: news?.description }} />

                <p className="name_text_hodler">
                  By <span>{news?.by_name}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Latest_updates_content;
